/**
 * late-apps.js
 * Laadt scripts van derden pas als de bezoeker iets doet, in plaats van meteen.
 * Toegevoegd 2 aug 2026
 *
 * WAAROM
 * ------
 * PageSpeed rekent je score uit door je pagina op een trage 4G-verbinding te
 * simuleren. Alles wat tijdens het laden binnenkomt, staat daar in dezelfde
 * wachtrij - ook scripts die pas veel later iets nuttigs doen. Klaviyo haalt
 * 13 bestanden en zo'n 78 KB binnen om gedrag te meten dat nog moet gebeuren.
 *
 * Dit bestand laadt die scripts pas bij de eerste scroll, tik of toetsaanslag.
 * Op dat moment is de pagina al zichtbaar en is de meting voorbij.
 *
 * WAT DIT KOST
 * ------------
 * Wees eerlijk over de keerzijde: een bezoeker die binnenkomt, niets doet en
 * weer wegklikt binnen de terugvaltijd hieronder, wordt niet meer geteld.
 * Voor de flows die daadwerkelijk in gebruik zijn - add-to-cart-mails en
 * bedankmails na een bestelling - verandert er niets, want daar moet de
 * bezoeker sowieso iets voor doen.
 *
 * De terugval van 7 seconden zorgt dat een rustig lezende bezoeker alsnog
 * geteld wordt.
 */
(function () {
  'use strict';

  var KLAVIYO_ID = 'UXRbTc';
  var TERUGVAL_MS = 7000;

  var geladen = false;
  var timer = null;

  var signalen = ['pointerdown', 'touchstart', 'keydown', 'wheel', 'scroll', 'mousemove'];

  function laadScript(src, attrs) {
    var s = document.createElement('script');
    s.src = src;
    s.async = true;
    if (attrs) {
      Object.keys(attrs).forEach(function (k) { s.setAttribute(k, attrs[k]); });
    }
    document.head.appendChild(s);
    return s;
  }

  function start() {
    if (geladen) return;
    geladen = true;

    signalen.forEach(function (naam) {
      window.removeEventListener(naam, start, true);
    });
    if (timer) { clearTimeout(timer); timer = null; }

    /*
      Klaviyo verwacht dat window._learnq bestaat voordat zijn script laadt.
      Bestellingen die vóór dit moment in de wachtrij zijn gezet - bijvoorbeeld
      door een ander script - worden dan alsnog netjes afgehandeld.
    */
    window._learnq = window._learnq || [];

    laadScript('https://static.klaviyo.com/onsite/js/' + KLAVIYO_ID + '/klaviyo.js');

    document.dispatchEvent(new CustomEvent('late-apps:geladen'));
  }

  signalen.forEach(function (naam) {
    window.addEventListener(naam, start, { capture: true, passive: true, once: true });
  });

  /* Terugval: ook zonder interactie uiteindelijk laden. */
  function zetTerugval() {
    timer = setTimeout(start, TERUGVAL_MS);
  }

  if (document.readyState === 'complete') {
    zetTerugval();
  } else {
    window.addEventListener('load', zetTerugval, { once: true });
  }
})();
